module.exports = __webpack_public_path__ + "img/png_wgzl_2@2x.4b7ecb31.png";